/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_MY_PROFILE = gql`
  query GetMyProfile {
    getMyProfile {
      vuid
      email
   kycSubmitted
      kyc {
        detail {
          gender
          occupation
          firstName
          lastName
          primaryContactNo
        address {
          addressLine1
          country
          state
          zipcode
          city
        }
        }
        docs {
          status
          fileType
          _id
          type
          doc
        }
        policies {
          policyId
          productDefination
        }
      }
      address {
        addressLine1
        addressLine2
        addressLine3
        city
        country
      }
    }
  }
`;

